import { action } from "mobx";
import TourStore from "~/stores/TourStore";

class TourIndexStore extends TourStore {
  @action
  getAll(infinite = false) {
    if (infinite) {
      this.pagination.currentPage += 1;
    }

    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
      orderBy: "creationDts",
      order: this.order,
    };

    if (this.searchParams.customerOrCoCustomerId !== "0") {
      params.customerOrCoCustomerId = this.searchParams.customerOrCoCustomerId;
    }

    if (this.searchParams.keywordString !== "") {
      params.keyword = this.searchParams.keywordString;
    }

    switch (this.searchParams.filterValue) {
      case "1":
        params.photosReady = 1;
        break;
      case "2":
        params.inProcess = 1;
        break;
      case "3":
        params.isActive = 0;
        break;
      case "4":
        params.awaitingPayment = 1;
        break;
      case "5":
        params.published = 1;
        params.isActive = 1;
        break;
      default:
    }

    return this.tourRepository.fetch(params).then(response => {
      this.processEntities(response.data.tours, infinite);
      if (!infinite) {
        this.processPagination(response.data.pagination);
      }
    });
  }
}

export default TourIndexStore;
